import {StyleSheet} from "aphrodite";

import {OnePaneDialog} from "@khanacademy/wonder-blocks-modal";

interface Props {
    title: string;
    content: React.ReactNode;
    footer: React.ReactNode;
}

/**
 * A modal that allows the user to attach an image from their device or
 * provide a URL to an image.
 */
export function ImageAttachModal({
    title,
    content,
    footer,
}: Props): React.ReactElement {
    return (
        <OnePaneDialog
            style={styles.modalContainer}
            content={content}
            footer={footer}
            title={title}
        />
    );
}

const styles = StyleSheet.create({
    modalContainer: {
        maxBlockSize: "90vh",
    },
});
